module.exports = __webpack_public_path__ + "static/PhotoBooth-2b774ffad11dac5c74e88cc37242705b.jpeg";